import { render, staticRenderFns } from "./aiBannerModifyPage.vue?vue&type=template&id=5005647c&scoped=true&"
import script from "./aiBannerModifyPage.vue?vue&type=script&lang=js&"
export * from "./aiBannerModifyPage.vue?vue&type=script&lang=js&"
import style0 from "./aiBannerModifyPage.vue?vue&type=style&index=0&id=5005647c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005647c",
  null
  
)

export default component.exports